import  iframeview from './component.vue'
export default (params,app) => {
    // app.$store.commit('main/menus/setIframeComponents',params)
    return {
        path: params.path,
        name: params.name,
        component: iframeview,
        meta: {
            title: params.title,
            linkUrl: params.linkUrl,
            isFrame: true
        }
    }
}